<template>
  <VUEModal v-if="PopupUdmX" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)" :Altezza="'80px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupUdmX()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="ObjGrafico.AxisX.UdmX"/>
        </div>

        <div style="">
          <label style="margin: 0px; font-weight: bold;">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div style="">
          <label style="margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div style="">
          <label style="margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>
      </div> 
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjGrafico.AxisX.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupImpostazioniAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupImpostazioniY()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjGrafico.AxisY.Min">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjGrafico.AxisY.Max">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjGrafico.AxisY.Udm">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupAddRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAddRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="width: 120px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_RIGHELLO',this.LinguaUtente) }}</p>
          <div style="width: 70%; display: flex; justify-content: space-between">
            <input class="form-control" style="width:55%; display: inline" type="date" v-model="ObjNewRighello.Data">
            <input class="form-control" style="width:40%; display: inline" type="time" v-model="ObjNewRighello.Ora">
          </div>
        </div>
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
          <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
          <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighello.Colore}" @click="ApriPopupColorPicker(ObjNewRighello.Colore, 'background')">&nbsp;</label>
        </div>            
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjNewRighello.Data != '' && ObjNewRighello.Ora != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupRemoveRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupRemoveRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 50%; display: flex; justify-content: space-between">
          <select class="form-control" v-model="RighelloToRemove">
            <option :value="''">-</option>
            <option v-for="Righello in ObjGrafico.ListaRighelli" :key="Righello.PrettyDateTime">{{ Righello.PrettyDateTime }}</option>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupSoglieConfig && this.Admin" :Titolo="SoglieConfigTitolo" Altezza="150px" Larghezza="400px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
          @onClickChiudiModal="PopupSoglieConfig = false" @onClickConfermaModal="SaveConfig()">
    <template v-slot:Body>
      <div style="font-size:14px; display:flex; flex-flow:column nowrap; padding:20px; gap:12px">
        <div style="display:flex; flex-flow:row nowrap; align-items:center; gap:10px;">
          <p style="width:50px; margin:0; font-weight:bold;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_SOGLIA_VISIBILE',this.LinguaUtente) }}</p>
          <input type="checkbox" v-model="SoglieConfigData.Visibile" style="margin-top:5px; width:20px; height:20px;">
        </div>
        <div style="display:flex; flex-flow:row nowrap; align-items:center; gap:35px;">
          <div style="display:flex; flex-flow:row nowrap; align-items:center; gap:5px;">
            <p style="margin:0; font-weight:bold; width:50px;">{{ GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_SOGLIA_COLORE',LinguaUtente) }}</p>
            <label class="form-control" style="width:80px; cursor:pointer; height:25px; margin:0;" :style="{ background: SoglieConfigData.Colore }" @click="ApriPopupColorPickerSoglie()">&nbsp;</label>
           </div>
           <div style="display:flex; flex-flow:row nowrap; align-items:center; gap:5px;">
            <p style="margin:0; font-weight:bold; width:60px;">{{ GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_SOGLIA_VALORE_Y',LinguaUtente) }}</p>
            <input class="form-control" type="number" step="0.01" v-model="SoglieConfigData.Y" style="width:100px; text-align:right;">
           </div>
         </div>
       </div>
    </template>
    <template v-slot:Footer>
      <button class="btn btn-danger" style="float:right; margin-left:10px; width:25%; font-weight:bold;" @click="PopupSoglieConfig = false">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button class="btn btn-success" style="float:right; width:25%; font-weight:bold;" @click="SaveConfig()">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>
  <VUEColorPicker :Popup="PopupColorPickerSoglie" Programma="DMSEW" :Colore="ColoreInModificaSoglie" @OnClickConfermaPopup="ConfermaColoreSoglie()" @OnClickChiudiPopup="AnnullaColoreSoglie()"></VUEColorPicker>
  <div style="min-height:500px; min-width:1200px">
    <div class="ZMSeparatoreScheda" style="margin-bottom:10px;margin-top:5px" :style="{'background-color' : ColoriPantone.Marrone }">
      <!-- {{ Sensore }} -->
      <text style="font-weight: bold;">{{this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) +  + Sensore.Id + ' - ' + this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ' ' + (Sensore.ProfonditaCoda ? Number(Sensore.ProfonditaCoda) : Number(Sensore.Profondita)) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente)}}</text>
    </div>
    <div style="width:83%;float:left" ref="DivCanvas">
      <VUEComponenteGraficoAccelerometri  :WidthGrafico="GrandezzaCanvas.Width" 
                                          :HeightGrafico="GrandezzaCanvas.Height"
                                          :Sensore="Sensore"
                                          :ObjDal="ObjDal"
                                          :ObjAl="ObjAl"
                                          :TipoGrafico="TipoGrafico"
                                          :PropsGrafico="ObjGrafico"
                                          :Repaint="Repaint"
                                          :RepaintDeep="RepaintDeep"
                                          :SoglieEvAcc="ObjSoglieEvAcc"/>
    </div>
      
    <div style="width:17%;float:left; border: solid 1px black" ref="DivButtons">
      <div style="margin-top:5px">
        <div style="float:left;width:4%;">&nbsp;</div>
        <div style="float:left;width:92%;">
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_F" style="float:left;width:85%;">
            <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px" :style="{ color: ColoreGraficoFreq }">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_N_EVENTI',this.LinguaUtente) }}</label>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjGrafico.X" @change="Repaint++" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:95%;">
            <label :style="{'color' : ColorLabelX}" style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;X</label>
          </div>  
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both;height:1px"></div>

          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjGrafico.Y" @change="Repaint++" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:95%;">
            <label :style="{'color' : ColorLabelY}" style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;Y</label>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both;height:1px"></div>
          
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjGrafico.Z" @change="Repaint++" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:95%;">
            <label :style="{'color' : ColorLabelZ}" style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;Z</label>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both;height:1px"></div>

          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjSoglieEvAcc.CfgSMS1.Attiva" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:85%;">
            <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px" :style="{ color: ObjSoglieEvAcc.CfgSMS1.Colore }">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_SOGLIA_SMS1',this.LinguaUtente) }}</label>
          </div> 
          <div v-if="this.Admin && TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:10%; text-align:right;">
            <i class="fa fa-bar-chart-o" style="font-size:20px; cursor:pointer;" @click="ApriPopupSoglieConfig('CfgSMS1')"></i>
          </div>
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both"></div>

          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjSoglieEvAcc.CfgSMS2.Attiva" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:85%;">
            <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px" :style="{ color: ObjSoglieEvAcc.CfgSMS2.Colore }">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_SOGLIA_SMS2',this.LinguaUtente) }}</label>
          </div> 
          <div v-if="this.Admin && TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:10%; text-align:right;">
            <i class="fa fa-bar-chart-o" style="font-size:20px; cursor:pointer;" @click="ApriPopupSoglieConfig('CfgSMS2')"></i>
          </div>
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both"></div>

          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjSoglieEvAcc.CfgSMS3.Attiva" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:85%;">
            <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px" :style="{ color: ObjSoglieEvAcc.CfgSMS3.Colore }">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_SOGLIA_SMS3',this.LinguaUtente) }}</label>
          </div> 
          <div v-if="this.Admin && TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:10%; text-align:right;">
            <i class="fa fa-bar-chart-o" style="font-size:20px; cursor:pointer;" @click="ApriPopupSoglieConfig('CfgSMS3')"></i>
          </div>
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both"></div>

          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjSoglieEvAcc.CfgSMS4.Attiva" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:85%;">
            <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px" :style="{ color: ObjSoglieEvAcc.CfgSMS4.Colore }">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_SOGLIA_SMS4',this.LinguaUtente) }}</label>
          </div> 
          <div v-if="this.Admin && TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:10%; text-align:right;">
            <i class="fa fa-bar-chart-o" style="font-size:20px; cursor:pointer;" @click="ApriPopupSoglieConfig('CfgSMS4')"></i>
          </div>
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both"></div>

          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjSoglieEvAcc.CfgRilevamento.Attiva" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:85%;">
            <label style="float:left;font-weight:bold;padding-left:12px;font-size:16px;margin-bottom:4px" :style="{ color: ObjSoglieEvAcc.CfgRilevamento.Colore }">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc','TKN_MOSTRA_SOGLIE',this.LinguaUtente) }}</label>
          </div>
          <div v-if="this.Admin && TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:10%; text-align:right;">
            <i class="fa fa-bar-chart-o" style="font-size:20px; cursor:pointer;" @click="ApriPopupSoglieConfig('CfgRilevamento')"></i>
          </div>
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both"></div>

          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:5%;">
            <input style="float:left;height:100%" v-model="ObjSoglieEvAcc.CfgAllarme.Attiva" type="checkbox" class="form-control"/>
          </div> 
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:85%;">
            <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px" :style="{ color: ObjSoglieEvAcc.CfgAllarme.Colore }">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('Generic','TKN_SOGLIA_ALLARME',this.LinguaUtente) }}</label>
          </div>
          <div v-if="this.Admin && TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="float:left;width:10%; text-align:right;">
            <i class="fa fa-bar-chart-o" style="font-size:20px; cursor:pointer;" @click="ApriPopupSoglieConfig('CfgAllarme')"></i>
          </div>
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_A" style="clear:both;height:7px"></div>
          <div v-if="TipoGrafico == TipiGrafici.EV_ACCELEROMETRICI_SINTETICI_F" style="clear:both;height:7px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="AdattaGrafico()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="ApriPopupUdmX()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="ApriPopupImpostazioniY()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="ApriPopupAddRighello()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ADD_RIGHELLO',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button :disabled="ObjGrafico.ListaRighelli.length == 0" type="button" class="btn btn-info" @click="ApriPopupRemoveRighello()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_DEL_RIGHELLO',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" style="width:100%" @click="EsportaComePDF()">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>
          
          
          <div style="clear:both;height:10px"></div>
        
        </div>   
        <div style="float:left;width:4%;">&nbsp;</div>
      </div>
    </div>
  </div>
  <div style="clear:both"></div>

</template>

<script>
import VUEComponenteGraficoAccelerometri from './VUEComponenteGraficoAccelerometri.vue'
import VUEModal from '@/utils/VUEModal.vue'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import { COLORI_PANTONE, TIPI_UDM_X, TIPOLOGIA_GRAFICI_STORICI, RUOLI, DEFAULT_SOGLIE_EV_ACC, SOGLIE_EV_ACC, SystemInformation, COLORE_GRAFICO_FREQUENZE } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler'

export default 
{
  data()
  {
   return {
            ColoriPantone          : COLORI_PANTONE,
            GrandezzaCanvas        : {
                                       Width  : 0,
                                       Height : 0
                                     },
            TipiUdmX               : TIPI_UDM_X,
            ColoreGraficoFreq      : COLORE_GRAFICO_FREQUENZE,
            Repaint                : 0,
            RepaintDeep            : 0,
            PopupUdmX              : false,
            PopupImpostazioniAsseY : false,
            PopupAddRighello       : false,
            PopupRemoveRighello    : false,
            PopupColorPicker       : false,
            ColorLabelX            : '#0000ff',
            ColorLabelY            : '#ff0000',
            ColorLabelZ            : '#008000',
            ColoreInModifica       : {Colore: '#000000'},
            ObjNewRighello         : {Data: '', Ora : '', DateTime : '',  PrettyDateTime: '', Colore: '#000000'},
            RighelloToRemove       : '',
            TipiGrafici            : TIPOLOGIA_GRAFICI_STORICI,
            LinguaUtente           : SystemInformation.UserInformation.Lingua,
            ColoreBottoni          : COLORI_PANTONE.Marrone,
            PopupSoglieConfig      : false,
            SoglieConfigTarget     : null,
            SoglieConfigData       : {Y : null, Colore : '#00ff00', Visibile : true},
            ObjGrafico             : {},
            ObjSoglieEvAcc         : {
                                       CfgSMS1        : { ...DEFAULT_SOGLIE_EV_ACC.SMS1 },
                                       CfgSMS2        : { ...DEFAULT_SOGLIE_EV_ACC.SMS2 },
                                       CfgSMS3        : { ...DEFAULT_SOGLIE_EV_ACC.SMS3 },
                                       CfgSMS4        : { ...DEFAULT_SOGLIE_EV_ACC.SMS4 },
                                       CfgRilevamento : { ...DEFAULT_SOGLIE_EV_ACC.Rilevamento },
                                       CfgAllarme     : { ...DEFAULT_SOGLIE_EV_ACC.Allarme }
                                     },                       
            PopupColorPickerSoglie : false,
            ColoreInModificaSoglie : {Colore: '#000000'}
          }
  },

  props : ['Sensore', 'ObjDal', 'ObjAl', 'TipoGrafico', 'GraficiChange', 'ParametriPDF', 'GetDatiPDF', 'MostraRilevamentoSoglia', 'NascondiRilevamentoSoglia'],
  emits : ['EsportaPDFGrafico', 'ModificaSoglie'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni, MixInsGraficiStorici],
  components:
  {
    VUEComponenteGraficoAccelerometri,
    VUEModal,
    VUEColorPicker
  },

  methods :
  {
    EsportaComePDF()
    {
      this.$emit('EsportaPDFGrafico', this.Sensore.Id)
    },

    GetGraficiPDF()
    {
      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []
      
      let ModuloPDF = TZGenericFunct.GetCopyOfObject(this.Sensore)

      ModuloPDF.Soglie = this.ObjSoglieEvAcc
      this.ObjPDF.PDFModulo.push(ModuloPDF)
      this.ObjPDF.PDFObjDatiGrafici.push(TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico))
    },

    SetMostraRilevamentoSoglia()
    {
      this.ObjSoglieEvAcc.CfgRilevamento.Attiva = true
    },

    SetNascondiRilevamentoSoglia()
    {
      this.ObjSoglieEvAcc.CfgRilevamento.Attiva = false
    },

    AdattaGrafico()
    {
      this.MixInsOnClickAdattaEvAcc(this.ObjGrafico)
    },

    CalcolaGrandezzaDivCanvas()
    {
      this.Repaint++
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = 540 // this.$refs.DivButtons.clientHeight
    },

    ApriPopupUdmX()
    {
      this.PopupUdmX = true
    },

    ConfermaPopupUdmX()
    {
      this.MixInsConfermaPopupUdmXEvAcc(this.ObjGrafico)
    },

    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false      
    },

    ApriPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = true
    },

    ConfermaPopupImpostazioniY()
    {
      this.MixInsConfermaPopupImpostazioniYEvAcc()
    },

    AnnullaPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = false
    },

    ApriPopupAddRighello()
    {
      this.PopupAddRighello = true
    },

    ConfermaPopupAddRighello()
    {
      this.MixInsConfermaPopupAddRighelloEvAcc(this.ObjGrafico)
    },

    AnnullaPopupAddRighello()
    {
      this.PopupAddRighello = false
      this.MixInsResetNewRighelloEvAcc()
    },

    ApriPopupRemoveRighello()
    {
      this.RighelloToRemove = ''
      this.PopupRemoveRighello = true
    },

    ConfermaPopupRemoveRighello()
    {
      this.MixInsConfermaPopupRemoveRighelloEvAcc(this.ObjGrafico)
    },

    AnnullaPopupRemoveRighello()
    {
      this.PopupRemoveRighello = false
    },

    ApriPopupColorPicker(Colore)
    {
      this.ColoreInModifica.Colore = Colore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ObjNewRighello.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },
    ApriPopupColorPickerSoglie() 
    {
      this.ColoreInModificaSoglie = this.SoglieConfigData
      this.PopupColorPickerSoglie = true
    },

    ConfermaColoreSoglie() 
    {
      this.PopupColorPickerSoglie = false
    },

    AnnullaColoreSoglie() 
    {
      this.PopupColorPickerSoglie = false
    },

    ApriPopupSoglieConfig(Target) 
    {
      this.SoglieConfigTarget = Target

      this.SoglieConfigData = {
                                Y        : this.ObjSoglieEvAcc[Target].Y,
                                Colore   : this.ObjSoglieEvAcc[Target].Colore,
                                Visibile : this.ObjSoglieEvAcc[Target].Visibile
                              }

      this.PopupSoglieConfig = true
    },

    SaveConfig() 
    {
      let SogliaId = DEFAULT_SOGLIE_EV_ACC[this.SoglieConfigTarget.replace('Cfg', '')].Tipologia; 

      let ObjQuery = { Operazioni: [] };

      ObjQuery.Operazioni.push({Query: 'UpdateSoglie',
                                Parametri: {
                                             CHIAVE    : SystemInformation.OggettoInfoGraficiStorici.IdCatena,
                                             ID_SOGLIA : SogliaId,
                                             Y         : this.SoglieConfigData.Y,
                                             COLORE    : this.SoglieConfigData.Colore,
                                             VISIBILE  : this.SoglieConfigData.Visibile  ? 'T' : 'F'
                                           }
                              });

      SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId;

      SystemInformation.AdvQuerySiti.PostSQL('Soglie_Eventi_Accelerometrici',
                                              ObjQuery,
                                              () => 
                                              {
                                                this.ObjSoglieEvAcc[this.SoglieConfigTarget] = { 
                                                                                                 ...this.ObjSoglieEvAcc[this.SoglieConfigTarget],
                                                                                                 Y        : this.SoglieConfigData.Y,
                                                                                                 Colore   : this.SoglieConfigData.Colore,
                                                                                                 Visibile : this.SoglieConfigData.Visibile
                                                                                               }

                                                this.PopupSoglieConfig = false;

                                                this.$emit('ModificaSoglie', true);

                                              },
                                              (HTTPError, SubHTTPError, Response) => 
                                              {
                                                SystemInformation.HandleError(HTTPError, SubHTTPError, Response);
                                              },
                                              false, { DMSEWSito: SystemInformation.OggettoInfoGraficiStorici.IdSito }
                                            );
    },
    ReloadSoglie()
    {
      let IdCatena = SystemInformation.OggettoInfoGraficiStorici.IdCatena;
      let IdSito   = SystemInformation.OggettoInfoGraficiStorici.IdSito;
      
      let Parametri = {
                    CHIAVE    : IdCatena,
                    DMSEWSito : IdSito
                  };
      SystemInformation.AdvQuerySiti.GetSQL('Soglie_Eventi_Accelerometrici',
                                                Parametri,
                                                (Results) => 
                                                {
                                                  let ArraySoglie = SystemInformation.AdvQuery.FindResults(Results, 'Soglie');

                                                  if (ArraySoglie && ArraySoglie.length > 0) 
                                                  {
                                                    ArraySoglie.forEach(Riga => 
                                                    {
                                                      this.ObjSoglieEvAcc['Cfg' + SOGLIE_EV_ACC[Riga.ID_SOGLIA]] = 
                                                      {
                                                        ...this.ObjSoglieEvAcc['Cfg' + SOGLIE_EV_ACC[Riga.ID_SOGLIA]],
                                                        Y        : Riga.GRANDEZZA,
                                                        Colore   : Riga.COLORE,
                                                        Visibile : Riga.VISIBILE === 'T'
                                                      };
                                                    });
                                                  }
                                                },
                                                SystemInformation.HandleError,
                                                'SelectSQL'
                                              );
    }

  },
  
  computed:
  {
    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    },
    SoglieConfigTitolo :
    {
      get()
      {
        let Associazione = {
                             CfgSMS1        : 'TKN_CONFIG_SMS1',
                             CfgSMS2        : 'TKN_CONFIG_SMS2',
                             CfgSMS3        : 'TKN_CONFIG_SMS3',
                             CfgSMS4        : 'TKN_CONFIG_SMS4',
                             CfgRilevamento : 'TKN_CONFIG_MOSTRA_SOGLIE',
                             CfgAllarme     : 'TKN_CONFIG_SOGLIA_ALLARME',
                           }
        let Token = Associazione[this.SoglieConfigTarget]
        return this.GetTraduzioneLabel('VUEFrameComponenteGraficoEvAcc',Token,this.LinguaUtente)
      } 
    }
  },
  
  watch:
  {
    GetDatiPDF :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    },

    MostraRilevamentoSoglia :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.SetMostraRilevamentoSoglia()
      }
    },

    NascondiRilevamentoSoglia :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.SetNascondiRilevamentoSoglia()
      }
    },

    GraficiChange:
    {
      handler()
      {
        this.ReloadSoglie()
        this.MixInsUpdateModificheGraficheEvAcc(this.ObjGrafico, this.Sensore)
      }
    }
  },

  beforeMount()
  {
    this.Admin = SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore
    this.MixInsSetObjGraficoEvAcc(this.ObjGrafico)

    let IdCatena = SystemInformation.OggettoInfoGraficiStorici.IdCatena;
    let IdSito   = SystemInformation.OggettoInfoGraficiStorici.IdSito;

    let Parametri = {
                      CHIAVE    : IdCatena,
                      DMSEWSito : IdSito
                    };

    SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId;

    SystemInformation.AdvQuerySiti.GetSQL('Soglie_Eventi_Accelerometrici',
                                           Parametri,
                                           (Results) => 
                                           {
                                             let ArraySoglie = SystemInformation.AdvQuery.FindResults(Results, 'Soglie');

                                             if (ArraySoglie && ArraySoglie.length > 0) 
                                             {
                                               ArraySoglie.forEach(Riga => 
                                               {
                                                 this.ObjSoglieEvAcc['Cfg' + SOGLIE_EV_ACC[Riga.ID_SOGLIA]] = 
                                                 {
                                                   ...this.ObjSoglieEvAcc['Cfg' + SOGLIE_EV_ACC[Riga.ID_SOGLIA]],
                                                   Y        : Riga.GRANDEZZA,
                                                   Colore   : Riga.COLORE,
                                                   Visibile : Riga.VISIBILE === 'T'
                                                 };
                                               });
                                             }
                                           },
                                           SystemInformation.HandleError,
                                           'SelectSQL'
                                         );
  },
  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
    window.addEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  },
  beforeUnmount()
  {
    window.removeEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  }
}
</script>